import React, { useState, useEffect } from 'react';
import { apiHolder as api, apis, getIn18Text } from 'api';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import './MailContentHeader.scss';
import FadeInOut from '@web-mail/common/components/transitions/FadeInOut';
import { debounceMailListRequest } from '@web-mail/util';
import IconSuccess from '@/components/UI/Icons/svgs/Success';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const getMailHeaders = debounceMailListRequest(mailApi.getMailHeaders.bind(mailApi));
const MailContentHeader = ({ mid, account, visiable, onVisiableChange }) => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const fetchMailHead = () => {
        if (mid) {
            getMailHeaders(mid, account).then((res) => {
                setLoading(false);
                setContent(res);
            });
        }
    };
    useEffect(() => {
        if (visiable) {
            setLoading(true);
            fetchMailHead();
        }
        else {
            setContent('');
            setLoading(false);
        }
    }, [visiable]);
    const handleClose = () => {
        onVisiableChange && onVisiableChange(false);
    };
    return (React.createElement(FadeInOut, { visiable: visiable, unmountOnHide: true },
        React.createElement("div", { className: "mail-content-header-wrap" },
            React.createElement("div", { className: "mch-head" },
                React.createElement("div", { className: "mch-icon" },
                    ' ',
                    React.createElement(IconSuccess, null)),
                React.createElement("div", { className: "mch-title" }, getIn18Text('YIXIANSHIYOUJIANXT')),
                React.createElement("div", { className: "mch-oper-wrap" },
                    React.createElement("div", { className: "mch-close", onClick: handleClose }, getIn18Text('CLOSE_AUTOLAUNCH')))),
            loading ? (React.createElement("div", { className: "mch-content  mch-content-loading" },
                React.createElement(LoadingOutlined, null))) : (React.createElement("pre", { className: "mch-content" }, content)))));
};
export default MailContentHeader;
